var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28454 0.641846H0.715456C0.0800264 0.641846 -0.242161 1.41152 0.214274 1.86796L3.48987 5.14355C3.77626 5.42994 4.22374 5.42994 4.51013 5.14355L7.78573 1.86796C8.24216 1.41152 7.91997 0.641846 7.28454 0.641846Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.80b4eaf407e6d6e6bff9d553396b78dd.svg";
export { ForwardRef as ReactComponent };